import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import warningCircleIcon from "assets/icons/warning-circle.svg";
import { FormattedMessage, useIntl } from "react-intl";
import propTypes from "prop-types";
import colors from "assets/styles/mixins/colors.scss";

const PastDateWarningModal = ({ open, onContinue, onClose, messageId }) => {
  const intl = useIntl();

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div
        className="validation-modal-style"
        style={{ backgroundColor: colors.lightYellow }}
      >
        <div className="header">
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <div>
            <div
              style={{
                backgroundImage: `url(${warningCircleIcon})`,
              }}
              className="validation-icon"
            />
          </div>
          <div className="title">
            {intl
              .formatMessage({
                id: "attention",
                defaultMessage: "Attention!",
              })
              .toUpperCase()}
          </div>
          <div className="description">
            <FormattedMessage id={messageId} />
          </div>
          <div className="form-buttons" style={{ marginTop: "2rem" }}>
            <Button
              color="btn-medium gray-700"
              type="button"
              onClick={onContinue}
              id="button-past-date-continue"
            >
              <FormattedMessage
                id="continue"
                defaultMessage="Continuer"
              />
            </Button>
          </div>
          <br /> <br />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default PastDateWarningModal;

PastDateWarningModal.propTypes = {
  open: propTypes.bool.isRequired,
  onContinue: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
  messageId: propTypes.string.isRequired,
};
